import React, { FunctionComponent } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { LoaderSize, LoaderTheme } from "./enum";

export type LoaderProps = {
    /**
     * Velikost loader
     */
    size?: LoaderSize;
    /**
     * Barevné téma loaderu
     */
    theme?: LoaderTheme;
};

const classNames = bemClassNames("loader-container");

export const Loader: FunctionComponent<LoaderProps> = ({
    size = LoaderSize.default,
    theme = LoaderTheme.default,
}) => {
    return (
        <div className={classNames({ size, theme })}>
            <div className="loader">
                <div className="left">
                    <div className="border"></div>
                </div>
                <div className="right">
                    <div className="border"></div>
                </div>
            </div>
        </div>
    );
};
